import { CSSColors } from 'Components/Colors';

export interface ChartDataItem {
    name: string;
    value: number;
    color?: CSSColors;
}

export interface ChartDimensions {
    width: number | string;
    height: number | string;
}

export interface ChartSeries {
    name: string;
    color: CSSColors;
    // TODO: The object version of the union is only used in one place, so all code has to become more complicated, with ripple effects, to support one exceptional case. Either move `itemStyle` to a separate attribute, or always use an object for this attribute, where `itemStyle` is optional.
    data: (number | { value: number; itemStyle: { color: string } })[];
}

// TODO: Is everything but the position optional solely because some charts add "empty" y-axes for some reason? Can we avoid doing that, or is there actually a reason that needs to be done?
export interface ChartAxis {
    name?: string;
    color?: CSSColors;
    labelFormatter?: (item: number) => string;
    position: 'left' | 'right';
    min?: number;
    max?: number;
    minInterval?: number;
    maxInterval?: number;
    interval?: number;
}

export const axisColor = '#6C757D';
export const chartFont = '--hps-primary-font';
export const chartColor = '--hps-light-gray';
